/** Accept real, complete calendar dates only; preserve other source wording for review. */
export const parseRateSheetCalendarDate = (
  value: string | null | undefined
): string | null => {
  const date = value?.trim();
  if (!date || !/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return null;
  }
  const parsed = new Date(`${date}T00:00:00.000Z`);
  if (
    Number.isNaN(parsed.getTime()) ||
    parsed.toISOString().slice(0, 10) !== date
  ) {
    return null;
  }
  return date;
};

/** UTC calendar dates are inclusive. Future replacements still take precedence. */
export const getRateSheetValidity = (
  validFrom: string | null | undefined,
  validUntil: string | null | undefined,
  today = new Date().toISOString().slice(0, 10)
): {
  status: 'valid' | 'unclear' | 'expired';
  startsInFuture: boolean;
  reversed: boolean;
} => {
  const from = parseRateSheetCalendarDate(validFrom);
  const until = parseRateSheetCalendarDate(validUntil);
  const reversed = !!from && !!until && from > until;
  return {
    status:
      until && until < today
        ? 'expired'
        : !from || !until || reversed
        ? 'unclear'
        : 'valid',
    startsInFuture: !!from && from > today,
    reversed,
  };
};
